import { Grid, Stack, TextField } from '@mui/material';

import Button from '@mui/material/Button';

import { SubmitHandler, useForm } from 'react-hook-form';

import { useTranslation } from '../../contexts/translation';

import { useEffect } from 'react';

import { DashboardOpcSettingInputs } from '../../types/app/dashboardOpcSetting';

import { dictionary } from '../../utils/core/dictionary';

interface Props {
  onSubmit: SubmitHandler<DashboardOpcSettingInputs>;
  defaultValues?: DashboardOpcSettingInputs;
  onBack: any;
}

export function DashbboardOpcSettingForm({ onSubmit, defaultValues, onBack }: Props) {
  const { t } = useTranslation();

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm<DashboardOpcSettingInputs>();

  useEffect(() => {
    reset({ ...defaultValues });
  }, [defaultValues, reset]);

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label={'Rows'}
              {...register('rows', {
                required: `Rows ${dictionary.IS_REQUIRED}`,
                validate: (value) =>
                  Number.isInteger(Number(value)) || 'Only whole numbers are allowed',
              })}
              error={Boolean(errors.rows)}
              helperText={errors.rows?.message}
              type="number"
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label={'Columns'}
              {...register('columns', {
                required: `Columns ${dictionary.IS_REQUIRED}`,
                validate: (value) =>
                  Number.isInteger(Number(value)) || 'Only whole numbers are allowed',
              })}
              error={Boolean(errors.columns)}
              helperText={errors.columns?.message}
              type="number"
            />
          </Grid>

          <Grid item>
            <Stack spacing={2} direction="row">
              <Button type="button" variant="outlined" onClick={onBack}>
                {t('general.action-buttons.back')}
              </Button>
              <Button type="submit" variant="contained" color="success">
                {t('general.action-buttons.save')}
              </Button>
            </Stack>
          </Grid>
        </Grid>
      </form>
    </>
  );
}
